export const CompanyFeaturesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CompanyFeatures' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'companyFeatures' },
                        name: { kind: 'Name', value: 'unstable_companyFeatures' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
